import { render, staticRenderFns } from "./CreatePruefungsstueckPage.vue?vue&type=template&id=3efe73ee"
import script from "./CreatePruefungsstueckPage.vue?vue&type=script&lang=js"
export * from "./CreatePruefungsstueckPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports